import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

// Brand block shown at the top of the sidebar. Gives the product a consistent
// identity (logo mark + "برنا" wordmark + tagline) across every screen.
const SidebarBrand = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        // Match the header height exactly and bleed the divider to the full
        // sidebar width so it lines up with the header's bottom border.
        height: '4rem',
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: '1rem',
        mx: '-1rem',
        borderBottom: `1px solid ${theme.palette.border.main}`,
      }}
    >
      <Box
        aria-hidden
        sx={{
          width: 40,
          height: 40,
          flexShrink: 0,
          borderRadius: '0.7rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          fontSize: '1.25rem',
          background: theme.palette.brand.gradient,
        }}
      >
        ب
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <Typography
          component="span"
          sx={{
            m: 0,
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.palette.text.default,
            textAlign: 'right',
          }}
        >
          برنا
        </Typography>
        <Typography
          component="span"
          sx={{
            m: 0,
            mt: 0.25,
            fontSize: '0.7rem',
            fontWeight: 400,
            color: theme.palette.text.secondary,
            textAlign: 'right',
          }}
        >
          سامانه مدیریت آموزشگاه
        </Typography>
      </Box>
    </Box>
  );
};

export default SidebarBrand;
